import type { ActionParams } from '@swf/components/StarsMPNotification/config/NotificationTypes';
import { dispatch } from '@swf/core/store';

import BonusExpired from '../../components/Bonus/Expired/Expired';
import { ActionType } from '../../enums';

import { TXTCLI_Instant_Bonus_Close_to_Expiry, TXTCLI_OK } from './Bonus.Expired.messages.json';

export default {
  front: {
    view: BonusExpired,
    viewConfig: {
      title: { tag: TXTCLI_Instant_Bonus_Close_to_Expiry },
      actions: [
        {
          actionType: ActionType.Primary,
          actionLabel: { tag: TXTCLI_OK },
          actionFunction: ({ notificationId }: ActionParams) => {
            dispatch.notification.delete({ notificationId });
            dispatch.modal.close('/mpnotifications');
          }
        }
      ]
    }
  }
};
